module.exports = __webpack_public_path__ + "img/img1.ec3d0f78.png";